import { render, staticRenderFns } from "./CompanyCertificateEdit.vue?vue&type=template&id=4dd78d21&scoped=true&"
import script from "./CompanyCertificateEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyCertificateEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCertificateEdit.vue?vue&type=style&index=0&id=4dd78d21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd78d21",
  null
  
)

export default component.exports